import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.75 6A2.25 2.25 0 0 1 10 3.75a.75.75 0 0 0 0-1.5 3.75 3.75 0 1 0 0 7.5.75.75 0 0 0 0-1.5A2.25 2.25 0 0 1 7.75 6m5 0a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M15 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M8.25 15A3.75 3.75 0 0 1 12 11.25h6A3.75 3.75 0 0 1 21.75 15v5A1.75 1.75 0 0 1 20 21.75H10A1.75 1.75 0 0 1 8.25 20zM12 12.75A2.25 2.25 0 0 0 9.75 15v5c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-5A2.25 2.25 0 0 0 18 12.75zM4.75 15A2.25 2.25 0 0 1 7 12.75h.5a.75.75 0 0 0 0-1.5H7A3.75 3.75 0 0 0 3.25 15v5a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }